import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { PUT } from '../../../../config/permissions';
import { generateEditBusMaintenaceStayPath } from '../../../../config/endpoints';

const EditMaintenanceBusFleetButton = ({
  handleEdit,
  maintenanceBusFleet,
  index,
}) => (
  <Button
    color="info"
    outline
    className="mr-3"
    onClick={() => handleEdit(maintenanceBusFleet, index)}
    title="Editar"
  >
    <i className="fa fa-pencil" />
  </Button>
);

EditMaintenanceBusFleetButton.propTypes = {
  maintenanceBusFleet: PropTypes.shape({}).isRequired,
  handleEdit: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default withEndpointAuthorization({
  url: generateEditBusMaintenaceStayPath(0),
  permissionType: PUT,
})(EditMaintenanceBusFleetButton);